import React from 'react';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';
import { useWebSocket } from '../../hooks/useWebSocket';

interface WebSocketStatusProps {
  showLabel?: boolean;
  className?: string;
}

export const WebSocketStatus: React.FC<WebSocketStatusProps> = ({ 
  showLabel = false,
  className = ''
}) => {
  const { connectionStatus } = useWebSocket();

  const getIcon = () => {
    switch (connectionStatus) {
      case 'connected':
        return <Wifi className="h-4 w-4 text-green-500" />;
      case 'connecting':
        return <Loader2 className="h-4 w-4 text-yellow-500 animate-spin" />;
      case 'disconnected':
      case 'error':
        return <WifiOff className="h-4 w-4 text-red-500" />;
      default:
        return <WifiOff className="h-4 w-4 text-gray-400" />;
    }
  };

  const getLabel = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'Conectado';
      case 'connecting':
        return 'Conectando...';
      case 'disconnected':
        return 'Desconectado';
      case 'error':
        return 'Error de conexión';
      default:
        return 'Sin conexión';
    }
  };

  const getTooltip = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'WebSocket conectado - Actualizaciones en tiempo real activas';
      case 'connecting':
        return 'Conectando a WebSocket...';
      case 'disconnected':
        return 'WebSocket desconectado - Sin actualizaciones en tiempo real';
      case 'error':
        return 'Error en la conexión WebSocket';
      default:
        return 'Estado de conexión desconocido';
    }
  };

  return (
    <div 
      className={`inline-flex items-center space-x-1 ${className}`}
      title={getTooltip()}
    >
      {getIcon()}
      {showLabel && (
        <span className="text-xs text-gray-600">
          {getLabel()}
        </span>
      )}
    </div>
  );
};